export default "__VITE_ASSET__PesmxhVX__"